import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useEffectOnce } from 'react-use';
import {
  ButtonLink,
  ButtonLinkProps,
} from '@lifeomic/chroma-react/components/ButtonLink';
import { Tooltip } from '@lifeomic/chroma-react/components/Tooltip';
import { BookOpen } from '@lifeomic/chromicons';
import linksJson from './links';
import { IconButtonLink } from '@lifeomic/chroma-react/components/IconButtonLink';

const messages = defineMessages({
  userGuideText: {
    id: 'detailsHeader.userGuideLink.userGuideText',
    defaultMessage: 'Help',
  },
  userGuideTooltip: {
    id: 'detailsHeader.userGuideLink.userGuideTooltip',
    defaultMessage: 'Open user guide in a new window',
  },
});

interface OwnProps {
  name: string;
  iconOnly?: boolean;
  className?: string;
}

type Props = OwnProps & Pick<ButtonLinkProps, 'variant' | 'color'>;

const UserGuideLink = ({
  name,
  className,
  variant = 'text',
  color = 'default',
  iconOnly = false,
}: Props) => {
  const { formatMessage } = useIntl();
  const [links, setLinks] = React.useState<Record<string, string>>();

  const getLinks = () => {
    return linksJson;
  };

  useEffectOnce(() => {
    setLinks(getLinks());
  });

  return links ? (
    <Tooltip title={formatMessage(messages.userGuideTooltip)}>
      {!iconOnly ? (
        <ButtonLink
          color={color}
          aria-label={formatMessage(messages.userGuideText)}
          to={links?.[name]}
          icon={BookOpen}
          disabled={!links}
          variant={variant}
          className={className}
        >
          {formatMessage(messages.userGuideText)}
        </ButtonLink>
      ) : (
        <IconButtonLink
          color={color}
          aria-label={formatMessage(messages.userGuideText)}
          to={links?.[name]}
          icon={BookOpen}
          className={className}
          size={0}
        />
      )}
    </Tooltip>
  ) : null;
};

export default UserGuideLink;
